<template>
  <div class="create">
    <div class="create__inner">
      <div class="create__head">
        <div>
          <router-link to="/predmeti" class="create__back">
            <i class="el-icon-back"></i> Predmeti
          </router-link>
          <h1 class="create__title">Novi predmet</h1>
        </div>
        <div class="create__head-actions">
          <el-button @click="cancel">Odustani</el-button>
          <el-button type="primary" :loading="saving" @click="handleSubmit">Sačuvaj predmet</el-button>
        </div>
      </div>

      <div v-if="errors.length" class="create__errors">
        <div class="create__errors-title">
          <i class="el-icon-warning-outline"></i> Popravite sljedeće prije snimanja
        </div>
        <ul>
          <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
        </ul>
      </div>

      <section class="card">
        <header class="card__head">
          <h2 class="card__title">Osnovno</h2>
          <span class="card__hint">Broj i datum se dodjeljuju automatski</span>
        </header>
        <div class="grid grid--3">
          <div class="field">
            <label>Broj predmeta</label>
            <el-input placeholder="Automatski" :disabled="true"></el-input>
          </div>
          <div class="field">
            <label>Godina</label>
            <el-input :disabled="true" v-model="formData.godina"></el-input>
          </div>
          <div class="field">
            <label>Datum prijema</label>
            <el-input :disabled="true" v-model="formData.datum_prijema"></el-input>
          </div>
          <div class="field">
            <label>Vrsta osiguranja <span class="req">*</span></label>
            <el-select class="w100" filterable v-model="formData.vrsta_osiguranja" placeholder="Odaberite vrstu">
              <el-option
                v-for="item in formContent.vrsta_osiguranja"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="field">
            <label>Nosioc</label>
            <el-select class="w100" v-model="formData.nosioc_id" placeholder="Ekspertiza">
              <el-option v-for="n in nosioci" :key="n.id" :label="n.naziv" :value="n.id"></el-option>
            </el-select>
          </div>
          <div class="field">
            <label>Obaveza</label>
            <div class="field__row">
              <el-select class="w100" multiple filterable v-model="formData.obaveza" placeholder="Odaberite obaveze">
                <el-option
                  v-for="item in formContent.obaveza"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button icon="el-icon-plus" title="Nova obaveza" @click="showQuickObaveza"></el-button>
            </div>
          </div>
          <div class="field">
            <label>Saradnik</label>
            <div class="field__row">
              <el-autocomplete
                class="w100"
                v-model="state.saradnik"
                :fetch-suggestions="fetchSradnik"
                placeholder="Pretraži saradnike"
                @select="selectSaradnik"
              >
                <template slot-scope="item">
                  {{ item.item.ime }} {{ item.item.prezime }}
                  <span class="lowlight">— TEL: {{ item.item.telefon }}</span>
                </template>
              </el-autocomplete>
              <el-button icon="el-icon-plus" title="Novi saradnik" @click="showQuickSaradnik"></el-button>
            </div>
          </div>
        </div>
      </section>

      <section class="card">
        <header class="card__head">
          <h2 class="card__title">Oštećeni i punomoćnici <span class="req">*</span></h2>
          <span class="card__hint">Dodajte barem jednog oštećenog</span>
        </header>

        <div class="op-add">
          <div class="field">
            <label>Oštećeni</label>
            <el-autocomplete
              class="w100"
              v-model="state.osteceni"
              :fetch-suggestions="fetchKontakt"
              placeholder="Pretraži kontakte"
              @select="selectOsteceni"
            >
              <template slot-scope="item">
                {{ item.item.ime }} {{ item.item.prezime }}
                <span class="lowlight">— TEL: {{ item.item.telefon }}</span>
              </template>
            </el-autocomplete>
          </div>

          <div class="field">
            <label>Punomoćnik</label>
            <el-autocomplete
              class="w100"
              v-model="state.punomocnik"
              :fetch-suggestions="fetchKontakt"
              placeholder="Pretraži kontakte"
              @select="selectPunomocnik"
              :disabled="state.oeqp"
            >
              <template slot-scope="item">
                {{ item.item.ime }} {{ item.item.prezime }}
                <span class="lowlight">— TEL: {{ item.item.telefon }}</span>
              </template>
            </el-autocomplete>
          </div>

          <div class="op-add__actions">
            <el-button icon="el-icon-plus" title="Novi kontakt" @click="showQuickKontakt"></el-button>
            <el-button type="primary" plain icon="el-icon-check" @click="addOP">Dodaj</el-button>
          </div>
        </div>

        <el-checkbox v-model="state.oeqp" class="op-same" @change="maybeEqualizeOP">
          Punomoćnik je isti kao oštećeni
        </el-checkbox>

        <div v-if="!state.optable.length" class="op-empty">
          Nijedan oštećeni još nije dodan
        </div>
        <ul v-else class="op-list">
          <li v-for="(op, i) in state.optable" :key="i" class="op-row">
            <div class="op-row__party">
              <span class="op-row__label">Oštećeni</span>
              <span class="op-row__name">{{ op.osteceni.ime }} {{ op.osteceni.prezime }}</span>
              <span class="op-row__meta">{{ op.osteceni.telefon }}</span>
            </div>
            <div class="op-row__party" v-if="op.punomocnik.id !== op.osteceni.id">
              <span class="op-row__label">Punomoćnik</span>
              <span class="op-row__name">{{ op.punomocnik.ime }} {{ op.punomocnik.prezime }}</span>
              <span class="op-row__meta">{{ op.punomocnik.telefon }}</span>
            </div>
            <div class="op-row__party op-row__party--muted" v-else>
              <span class="op-row__label">Punomoćnik</span>
              <span class="op-row__name">isti kao oštećeni</span>
            </div>
            <el-button
              class="op-row__del"
              icon="el-icon-delete"
              title="Ukloni"
              @click="deleteOP(op.osteceni.id, op.punomocnik.id)"
            ></el-button>
          </li>
        </ul>
      </section>

      <section class="card" v-if="isVehicleVrsta">
        <header class="card__head">
          <h2 class="card__title">Vozilo</h2>
          <span class="card__hint">Za autoodgovornost i kasko</span>
        </header>
        <div class="grid grid--2">
          <div class="field">
            <label>Registarska oznaka</label>
            <el-input v-model="formData.meta.registarska_oznaka" placeholder="npr. E37-M-545" autocomplete="off"></el-input>
          </div>
          <div class="field">
            <label>Godište</label>
            <el-select class="w100" filterable v-model="formData.meta.godiste" placeholder="Odaberite godište">
              <el-option v-for="item in formContent.godista" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
          <div class="field">
            <label>Marka</label>
            <div class="field__row">
              <el-select
                class="w100"
                filterable
                v-model="formData.meta.brend_id"
                placeholder="Odaberite marku"
                @change="handleBrendChange"
              >
                <el-option v-for="item in formContent.brend" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-button icon="el-icon-plus" title="Nova marka" @click="showQuickBrend"></el-button>
            </div>
          </div>
          <div class="field">
            <label>Model</label>
            <div class="field__row">
              <el-select
                class="w100"
                filterable
                v-model="formData.meta.auto_model_id"
                placeholder="Odaberite model"
                :disabled="formData.meta.brend_id === undefined"
              >
                <el-option v-for="item in formContent.auto_model" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-button
                icon="el-icon-plus"
                title="Novi model"
                @click="showQuickAutoModel"
                :disabled="formData.meta.brend_id === undefined"
              ></el-button>
            </div>
          </div>
        </div>
      </section>

      <section class="card">
        <header class="card__head">
          <h2 class="card__title">Napomena</h2>
        </header>
        <el-input
          type="textarea"
          :autosize="{ minRows: 3 }"
          placeholder="Kratka bilješka o predmetu…"
          v-model="formData.napomena"
        ></el-input>
      </section>

      <div class="create__foot">
        <el-button @click="cancel">Odustani</el-button>
        <el-button type="primary" :loading="saving" @click="handleSubmit">Sačuvaj predmet</el-button>
      </div>
    </div>

    <el-dialog title="Novi kontakt" :visible.sync="state.quickKontakt" width="460px">
      <el-form :model="state.kontaktForm" label-position="top">
        <el-form-item label="Ime *">
          <el-input v-model="state.kontaktForm.ime" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Prezime *">
          <el-input v-model="state.kontaktForm.prezime" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Adresa">
          <el-input v-model="state.kontaktForm.adresa" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Telefon *">
          <el-input v-model="state.kontaktForm.telefon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="state.kontaktForm.email" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickKontakt = false">Odustani</el-button>
        <el-button type="primary" @click="createKontakt">Sačuvaj</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Nova obaveza" :visible.sync="state.quickObaveza" width="460px">
      <el-form :model="state.obavezaForm" label-position="top">
        <el-form-item label="Naziv *">
          <el-input v-model="state.obavezaForm.naziv" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Opis">
          <el-input v-model="state.obavezaForm.opis" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Adresa">
          <el-input v-model="state.obavezaForm.adresa" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Telefon">
          <el-input v-model="state.obavezaForm.telefon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="state.obavezaForm.email" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickObaveza = false">Odustani</el-button>
        <el-button type="primary" @click="createObaveza">Sačuvaj</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Nova marka" :visible.sync="state.quickBrend" width="420px">
      <el-form :model="state.brendForm" label-position="top">
        <el-form-item label="Naziv *">
          <el-input v-model="state.brendForm.naziv" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickBrend = false">Odustani</el-button>
        <el-button type="primary" @click="createBrend">Sačuvaj</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Novi model" :visible.sync="state.quickAutoModel" width="420px">
      <el-form :model="state.autoModelForm" label-position="top">
        <el-form-item label="Naziv *">
          <el-input v-model="state.autoModelForm.naziv" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickAutoModel = false">Odustani</el-button>
        <el-button type="primary" @click="createAutoModel">Sačuvaj</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Novi saradnik" :visible.sync="state.quickSaradnik" width="460px">
      <el-form :model="state.saradnikForm" label-position="top">
        <el-form-item label="Ime *">
          <el-input v-model="state.saradnikForm.ime" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Prezime *">
          <el-input v-model="state.saradnikForm.prezime" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Adresa">
          <el-input v-model="state.saradnikForm.adresa" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Telefon *">
          <el-input v-model="state.saradnikForm.telefon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="state.saradnikForm.email" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickSaradnik = false">Odustani</el-button>
        <el-button type="primary" @click="createSaradnik">Sačuvaj</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { loadNosioci, defaultNosioc } from "@/models/nosioc";
import API from "@/services/api/api";
import DataService from "@/services/data.service";
import authHeader from "@/services/auth-header";

export default {
  name: "PredmetCreate",
  components: {},
  data() {
    return {
      vehicleVrste: [],
      state: {
        api_url: "",
        kontaktForm: {},
        obavezaForm: {},
        brendForm: {},
        autoModelForm: {},
        saradnikForm: {},
        oeqp: true,
        // Declared up front: v-model on an undeclared property is not
        // reactive in Vue 2, so the field kept snapping back to the
        // previous saradnik and typing landed on the end of it.
        saradnik: "",
        osteceni: "",
        osteceni_obj: {},
        punomocnik: "",
        punomocnik_obj: {},
        optable: [],
        quickKontakt: false,
        quickObaveza: false,
        quickBrend: false,
        quickAutoModel: false,
        quickSaradnik: false,
      },
      nosioci: [],
      formData: {
        godina: moment().format("YYYY"),
        datum_prijema: moment().format("DD/MM/YYYY"),
        meta: {},
        // Ekspertiza unless someone hands the case to a lawyer up front.
        nosioc_id: null,
      },
      formContent: {
        vrsta_osiguranja: [],
        obaveza: [],
        godista: [],
        brend: [],
        auto_model: [],
        saradnik: [],
      },
      errors: [],
      saving: false,
    };
  },
  watch: {
    // Once the banner is up, let it clear itself as fields get fixed.
    "formData.vrsta_osiguranja": function () {
      if (this.errors.length) this.errors = this.validate();
    },
    "state.optable": {
      handler: function () {
        if (this.errors.length) this.errors = this.validate();
      },
      deep: true,
    },
  },
  computed: {
    isVehicleVrsta() {
      return this.vehicleVrste.indexOf(this.formData.vrsta_osiguranja) !== -1;
    },
  },
  methods: {
    handleClick: () => {},
    validate: function () {
      const errors = [];
      if (typeof this.formData.vrsta_osiguranja == "undefined") {
        errors.push("Odaberite vrstu osiguranja.");
      }
      if (this.state.optable.length == 0) {
        errors.push("Dodajte barem jednog oštećenog.");
      }
      return errors;
    },
    handleBrendChange: function () {
      delete this.formData.meta.auto_model_id;
      this.loadAutoModel();
    },
    cancel: function () {
      this.$router.push("/predmeti");
    },
    handleSubmit: async function () {
      this.errors = this.validate();
      if (this.errors.length > 0) {
        return;
      }
      this.saving = true;
      let req = {
        datum_prijema: moment().utcOffset(0, true).format(),
        godina: parseInt(this.formData.godina, 10),
        meta: global.toObject(this.formData.meta),
        napomena: this.formData.napomena,
        obaveza_id: this.formData.obaveza,
        saradnik_id: this.formData.saradnik,
        nosioc_id: this.formData.nosioc_id || undefined,
        vrsta_osiguranja_id: this.formData.vrsta_osiguranja,
        osteceni_ids: [],

        // compatibility fields
        broj: "",
        osteceni_id: 0,
        punomocnik_id: 0,
      };

      this.state.optable.forEach((op) => {
        req.osteceni_ids.push({
          oid: op.osteceni.id,
          pid: op.punomocnik.id,
        });
      });
      console.log(req);
      try {
        const res = await API.Generic.create("predmet", req);
        this.$router.push("/predmet/view/" + res.data.data.id.toString());
      } catch (e) {
        this.errors = ["Predmet nije sačuvan — došlo je do sistemske greške."];
        console.log(e);
      } finally {
        this.saving = false;
      }
    },
    showQuickKontakt: function () {
      this.state.kontaktForm = {};
      this.state.quickKontakt = true;
    },
    createKontakt: async function () {
      console.log("createKontakt", this.state.kontaktForm);
      try {
        await API.Generic.create("kontakt", this.state.kontaktForm);
        this.state.quickKontakt = false;
      } catch (e) {
        console.log(e);
      }
    },
    showQuickSaradnik: function () {
      this.state.saradnikForm = {};
      this.state.quickSaradnik = true;
    },
    createSaradnik: async function () {
      console.log("createSradnik", this.state.saradnikForm);
      try {
        await API.Generic.create("saradnik", this.state.saradnikForm);
        this.state.quickSaradnik = false;
      } catch (e) {
        console.log(e);
      }
    },
    showQuickAutoModel: function () {
      this.state.autoModelForm = {};
      this.state.quickAutoModel = true;
    },
    createAutoModel: async function () {
      try {
        await API.Generic.create("auto_model", {
          ...this.state.autoModelForm,
          brend_id: this.formData.meta.brend_id,
        });
        this.state.quickAutoModel = false;
        delete this.formData.meta.auto_model_id;
        this.loadAutoModel();
      } catch (e) {
        console.log(e);
      }
    },
    showQuickBrend: function () {
      this.state.brendForm = {};
      this.state.quickBrend = true;
    },
    createBrend: async function () {
      try {
        await API.Generic.create("brend", this.state.brendForm);
        this.state.quickBrend = false;
        delete this.formData.meta.auto_model_id;
        delete this.formData.meta.brend_id;
        this.loadBrend();
      } catch (e) {
        console.log(e);
      }
    },
    showQuickObaveza: function () {
      this.state.obavezaForm = {};
      this.state.quickObaveza = true;
    },
    createObaveza: async function () {
      console.log("createObaveza", this.state.obavezaForm);
      try {
        await API.Generic.create("obaveza", this.state.obavezaForm);
        await this.loadObaveza();
        this.state.quickObaveza = false;
      } catch (e) {
        console.log(e);
      }
    },
    addOP: function () {
      if (this.state.osteceni !== "" && this.state.punomocnik !== "") {
        let duplicate = false;
        this.state.optable.forEach((op) => {
          if (
            op.osteceni.id === this.state.osteceni_obj.id &&
            op.punomocnik.id === this.state.punomocnik_obj.id
          ) {
            duplicate = true;
            return;
          }
        });
        if (duplicate) {
          return;
        }
        this.state.optable.push({
          osteceni: this.state.osteceni_obj,
          punomocnik: this.state.punomocnik_obj,
        });
        this.state.osteceni_obj = {};
        this.state.osteceni = "";
        this.state.punomocnik_obj = {};
        this.state.punomocnik = "";
      }
    },
    deleteOP: function (oid, pid) {
      for (var i = 0; i < this.state.optable.length; i++) {
        if (
          this.state.optable[i].osteceni.id === oid &&
          this.state.optable[i].punomocnik.id === pid
        ) {
          this.state.optable.splice(i, 1);
        }
      }
    },
    maybeEqualizeOP: function () {
      if (this.state.oeqp) {
        this.state.punomocnik = this.state.osteceni;
        this.state.punomocnik_obj = this.state.osteceni_obj;
      }
    },
    selectOsteceni: function (item) {
      console.log(item);
      this.state.osteceni = item.ime + " " + item.prezime;
      this.state.osteceni_obj = item;
      this.maybeEqualizeOP();
    },
    selectSaradnik: function (item) {
      console.log(item);
      this.formData.saradnik = item.id;
      this.state.saradnik = item.ime + " " + item.prezime;
    },
    selectPunomocnik: function (item) {
      this.state.punomocnik = item.ime + " " + item.prezime;
      this.state.punomocnik_obj = item;
    },
    fetchKontakt: async function (q, done) {
      try {
        let res = await API.Generic.search("kontakt", q);
        let kontakti = res.data.data.results;
        done(kontakti);
      } catch (e) {
        console.log(e);
      }
    },
    fetchSradnik: async function (q, done) {
      try {
        let res = await API.Generic.search("saradnik", q);
        let s = res.data.data.results;
        done(s);
      } catch (e) {
        console.log(e);
      }
    },
    loadBrend: async function () {
      return API.Generic.all("brend")
        .then((data) => {
          let d = data.data.data;
          this.formContent.brend = [];
          d.results.forEach((o) => {
            this.formContent.brend.push({
              value: o.id,
              label: o.naziv,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadAutoModel: async function () {
      return API.Generic.all("auto_model", {
        brend_id: { val: this.formData.meta.brend_id },
      })
        .then((data) => {
          let d = data.data.data;
          this.formContent.auto_model = [];
          d.results.forEach((o) => {
            this.formContent.auto_model.push({
              value: o.id,
              label: o.naziv,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadGodista: function () {
      var years = [];
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      for (var i = 0; i < 50; i++) {
        var strYear = (currentYear - i).toString();
        years.push({ id: strYear, name: strYear });
      }
      this.formContent.godista = years;
    },
    loadObaveza: async function () {
      return API.Generic.all("obaveza")
        .then((data) => {
          let d = data.data.data;
          this.formContent.obaveza = [];
          d.results.forEach((o) => {
            this.formContent.obaveza.push({
              value: o.id,
              label: o.naziv,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadVrstaOsiguranja: async function () {
      return API.Generic.all("vrsta_osiguranja")
        .then((data) => {
          let d = data.data.data;
          d.results.forEach((o) => {
            this.formContent.vrsta_osiguranja.push({
              value: o.id,
              label: o.naziv,
            });
            // Which types carry a vehicle comes from the data, so inserting
            // a type into the middle of the list cannot get it wrong.
            if (o.vozilo) this.vehicleVrste.push(o.id);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.state.api_url = DataService.api();
    this.state.authHeader = authHeader();
    loadNosioci()
      .then((list) => {
        this.nosioci = list;
        const d = defaultNosioc(list);
        if (d && !this.formData.nosioc_id) this.formData.nosioc_id = d.id;
      })
      .catch((e) => console.log(e));
    this.loadVrstaOsiguranja();
    this.loadObaveza();
    this.loadGodista();
    this.loadBrend();
  },
};
</script>

<style lang="scss" scoped>
.create {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
}

.create__inner {
  max-width: 1040px;
  margin: 0 auto;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.create__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.create__back {
  font-size: var(--fs-sm);
  color: var(--ink-3);
  text-decoration: none;

  &:hover {
    color: var(--brand-ink);
  }
}

.create__title {
  font-size: var(--fs-title);
  font-weight: 700;
  color: var(--ink);
  margin: 3px 0 0 0;
}

.create__head-actions,
.create__foot {
  display: flex;
  gap: 8px;
}

.create__foot {
  justify-content: flex-end;
}

.create__errors {
  background: var(--danger-tint);
  border: 1px solid var(--danger-line);
  color: var(--danger);
  border-radius: var(--r-lg);
  padding: 12px 14px;
  font-size: var(--fs-md);

  ul {
    margin: 6px 0 0 0;
    padding-left: 20px;
  }

  li + li {
    margin-top: 2px;
  }
}

.create__errors-title {
  font-weight: 600;
}

.card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  padding: 18px;
}

.card__head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 14px;
}

.card__title {
  font-size: var(--fs-lg);
  font-weight: 600;
  color: var(--ink);
  margin: 0;
}

.card__hint {
  font-size: var(--fs-sm);
  color: var(--ink-4);
}

.req {
  color: var(--danger);
}

.grid {
  display: grid;
  gap: 14px 16px;
}

.grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.field {
  min-width: 0;

  label {
    display: block;
    font-size: var(--fs-sm);
    color: var(--ink-2);
    margin-bottom: 5px;
  }
}

// Field plus its "add new" button, so the button never overlaps the input.
.field__row {
  display: flex;
  gap: 8px;
  align-items: flex-start;

  > *:first-child {
    flex-grow: 1;
    min-width: 0;
  }
}

.w100 {
  width: 100%;
}

.op-add {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  gap: 14px 16px;
  align-items: end;
}

.op-add__actions {
  display: flex;
  gap: 8px;
}

.op-same {
  display: block;
  margin-top: 12px;
  font-size: var(--fs-md);
}

.op-empty {
  margin-top: 14px;
  padding: 20px;
  border: 1px dashed var(--line-strong);
  border-radius: var(--r-md);
  text-align: center;
  font-size: var(--fs-md);
  color: var(--ink-4);
}

.op-list {
  list-style: none;
  margin: 14px 0 0 0;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  overflow: hidden;
}

.op-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  padding: 10px 14px;

  & + & {
    border-top: 1px solid var(--line-soft);
  }
}

.op-row__party {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.op-row__party--muted .op-row__name {
  color: var(--ink-4);
  font-weight: 400;
  font-style: italic;
}

.op-row__label {
  font-size: var(--fs-xs);
  color: var(--ink-4);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.op-row__name {
  font-size: var(--fs-md);
  font-weight: 500;
  color: var(--ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.op-row__meta {
  font-size: var(--fs-sm);
  color: var(--ink-3);
}

.lowlight {
  font-size: var(--fs-sm);
  color: var(--ink-4);
}
</style>
